/* Event */

jQuery(document).ready(function ($) {
    if ($("#filterDropDownList").length) {
        updateQueryString($("#filterDropDownList").val());
    }
});

function updateQueryString(filter) {
    //Get all query string parameters.
    var parameters = getUrlVarsObjectCollection();

    //If the filter is blank, only apply it to the query string if there was a sort parameter previously.  This prevents it from changing the query string when the page is initially displayed.
    if (filter === "") {
        //alert(parameters["sort"]);
        if (parameters["sort"] !== undefined) {
            parameters["sort"] = filter;
        }
    } else {
        parameters["sort"] = filter;
    }

    //Only change the query string if there is a sort parameter.
    if (parameters["sort"] !== undefined) {
        window.history.replaceState({}, document.title, location.protocol + '//' + location.host + location.pathname + "?" + $.param(parameters));
    }
}

/**
 * Returns the collection of url query string parameters as an object.  This collection can then be used as data in ajax calls, the array returned in getUrlVars() cannot. 
 */
function getUrlVarsObjectCollection() {
    var vars = {}, hash;

    //Check to see that there is a question mark in the href, otherwise it will take the entire url.  If there isn't a question mark, there aren't any parameters so we can
    //just return an empty array.
    if (window.location.href.indexOf('?') > -1) {
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');

            vars[hash[0]] = hash[1];
        }
    }

    return vars;
}